import { authorizedAPI } from '@/config/axios.config';
import { UtilsService } from '../utils';

const utils = new UtilsService();

class BackupService {
  async createBackup(): Promise<void> {
    try {
      const response = await authorizedAPI.get('/backup/create', {
        responseType: 'blob',
      });

      const contentDisposition =
        response.headers?.['content-disposition'] ||
        response.headers?.['Content-Disposition'] ||
        (response.headers as any)?.contentDisposition ||
        (response.headers as any)?.common?.['content-disposition'] ||
        (response.headers as any)?.common?.['Content-Disposition'];

      let filename = 'backup.zip';

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].trim();
        }
      }

      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw error;
    }
  }
}

export const backupService = new BackupService();


